
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { useNavigate } from "react-router-dom";

interface FavoriteCardProps {
  favorite: {
    id: string;
    name: string;
    category: string;
    image?: string;
    slug?: string;
  };
}

const FavoriteCard = ({ favorite }: FavoriteCardProps) => {
  const navigate = useNavigate();

  const handleFavoriteClick = (providerSlug: string) => {
    console.log('Navigating to provider slug:', providerSlug);
    navigate(`/provider/${providerSlug}`);
  };

  return (
    <Card 
      key={favorite.id} 
      className="hover:shadow-md transition-shadow cursor-pointer"
      onClick={() => handleFavoriteClick(favorite.slug || favorite.id)}
    >
      <CardContent className="p-4">
        <div className="flex items-center space-x-4">
          {favorite.image ? (
            <Avatar className="w-12 h-12">
              <AvatarImage src={favorite.image} alt={favorite.name} />
              <AvatarFallback className="bg-gradient-to-r from-blue-600 to-purple-600 text-white font-bold text-sm">
                {favorite.name.split(' ').map(word => word[0]).join('')}
              </AvatarFallback>
            </Avatar>
          ) : (
            <div className="w-12 h-12 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full flex items-center justify-center">
              <span className="text-white font-bold text-sm">
                {favorite.name.split(' ').map(word => word[0]).join('')}
              </span>
            </div>
          )}
          <div className="flex-1">
            <h3 className="font-semibold">{favorite.name}</h3>
            <p className="text-sm text-gray-600">{favorite.category}</p>
          </div>
        </div>
        <Button 
          className="w-full mt-4" 
          variant="outline"
          onClick={(e) => {
            e.stopPropagation();
            console.log('Book Now clicked for provider slug:', favorite.slug || favorite.id);
            navigate(`/provider/${favorite.slug || favorite.id}`);
          }}
        >
          Book Now
        </Button>
      </CardContent>
    </Card>
  );
};

export default FavoriteCard;
